import { VFadeTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c(VFadeTransition,{attrs:{"leave-absolute":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }